import React from 'react';
import PropTypes from 'prop-types';

import UserIconList from 'components/user_icon_list';

import './styles.scss';

export default function DealBrokers({ deal }) {
  return <UserIconList size="30px" users={deal.brokers} />;
}

DealBrokers.propTypes = {
  deal: PropTypes.shape({
    brokers: PropTypes.array.isRequired,
  }).isRequired,
};
